module.exports = __webpack_public_path__ + "img/service-after-content-support@3x.fde55d16.png";